class UncsMultiCollectionSlider extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.panels = this.querySelectorAll('[data-multi-collection-panel]');
    this.tabs = this.querySelectorAll('[data-multi-collection-tab]');
  }

  connectedCallback() {
    this.tabs.forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });
    this.initVariantThumbs();
  }

  initVariantThumbs() {
    this.querySelectorAll('.product-variant-thumbs').forEach((group) => {
      if (group.querySelectorAll('img').length === 0) {
        const card = group.closest('li');
        const mainImg = card && card.querySelector('img.motion-reduce');
        if (mainImg && mainImg.getAttribute('src')) {
          const fallback = document.createElement('img');
          fallback.setAttribute('src', mainImg.getAttribute('src'));
          fallback.setAttribute('alt', mainImg.getAttribute('alt') || '');
          fallback.setAttribute('width', 'auto');
          fallback.setAttribute('height', 'auto');
          group.appendChild(fallback);
        }
      }
      const thumbs = group.querySelectorAll('img');
      if (thumbs.length === 0) return;
      thumbs[0].classList.add('is-current');
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          thumbs.forEach((other) => other.classList.remove('is-current'));
          thumb.classList.add('is-current');
        });
      });
    });
  }

  onTabClick(event) {
    const targetKey = event.currentTarget.dataset.multiCollectionTab;
    if (!targetKey) return;

    this.suppressStickyHeaderScroll();
    this.activateTab(targetKey);

    document.querySelectorAll('uncs-multi-collection-slider').forEach((other) => {
      if (other === this) return;
      other.activateTab(targetKey);
    });
  }

  activateTab(key) {
    const targetTab = this.querySelector(`[data-multi-collection-tab="${key}"]`);
    if (!targetTab) return false;

    this.tabs.forEach((tab) => {
      const isActive = tab === targetTab;
      tab.classList.toggle('uncs-multi-collection-slider__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.multiCollectionPanel === key;
      if (isActive) {
        panel.removeAttribute('hidden');
        const slider = panel.querySelector('slider-component');
        if (slider && typeof slider.resetPages === 'function') {
          requestAnimationFrame(() => slider.resetPages());
        }
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    return true;
  }

  suppressStickyHeaderScroll() {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;

    stickyHeader.dispatchEvent(
      new CustomEvent('suppressHeaderScroll', {
        detail: { duration: 300 },
      }),
    );
  }
}

if (!customElements.get('uncs-multi-collection-slider')) {
  customElements.define('uncs-multi-collection-slider', UncsMultiCollectionSlider);
}

function syncMultiCollectionSliders() {
  const sliders = document.querySelectorAll('uncs-multi-collection-slider');
  if (sliders.length < 2) return;

  const firstActiveTab = sliders[0].querySelector('[data-multi-collection-tab].uncs-multi-collection-slider__tab--active');
  const key = firstActiveTab && firstActiveTab.dataset.multiCollectionTab;
  if (!key) return;

  for (let i = 1; i < sliders.length; i++) {
    sliders[i].activateTab(key);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', syncMultiCollectionSliders);
} else {
  syncMultiCollectionSliders();
}
